const roleConfig = [
    { key: "top", label: "Top", icon: "position-top-light.svg" },
    { key: "jungle", label: "Jungle", icon: "position-jungle-light.svg" },
    { key: "middle", label: "Mid", icon: "position-middle-light.svg" },
    { key: "bottom", label: "Bottom", icon: "position-bottom-light.svg" },
    { key: "support", label: "Support", icon: "position-utility-light.svg" },
]

const PreferredRole = ({ preferredRole }) => {
    const totalGames = roleConfig.reduce(
        (sum, role) => sum + (preferredRole?.[role.key] || 0),
        0
    )

    return (
        <section className="mb-3 rounded-xl border border-zinc-800 bg-zinc-950 px-4 py-4 text-zinc-200 shadow-[0_18px_36px_-28px_rgba(0,0,0,0.95)]">
            <div className="-mx-4 -mt-4 mb-3 border-b border-zinc-800 bg-zinc-900/65 px-4 py-3 text-left">
                <h2 className="text-[10px] font-bold uppercase tracking-[0.14em] text-zinc-500">PREFERRED POSITION</h2>
            </div>

            <div className="mt-3 grid grid-cols-5 gap-[6px] justify-items-center max-w-[260px] mx-auto">
                {roleConfig.map((role) => {
                    const gamesInRole = preferredRole?.[role.key] || 0
                    const percentage =
                        totalGames > 0
                            ? Math.round((gamesInRole / totalGames) * 100)
                            : 0

                    const rawHeight = Math.round((percentage / 100) * 72)
                    const height =
                        percentage > 0 ? Math.max(4, rawHeight) : 0

                    return (
                        <div
                            key={role.key}
                            className="flex flex-col items-center gap-2"
                        >
                            <div className="w-[20px] h-[72px] rounded-sm border border-zinc-700 bg-zinc-900 flex items-end overflow-hidden">
                                {percentage > 0 && (
                                    <div
                                        className="w-full bg-zinc-700 transition-[height] duration-200 ease-out"
                                        style={{ height: `${height}px` }}
                                    />
                                )}
                            </div>

                            <img
                                alt={`${role.label} role icon`}
                                className="h-4 w-4 opacity-100"
                                src={
                                    process.env.PUBLIC_URL +
                                    `/assets/role_icons/${role.icon}`
                                }
                            />
                        </div>
                    )
                })}
            </div>
        </section>
    )
}

export default PreferredRole
